


















import {Component, Prop, Vue} from "vue-property-decorator";
import {HTTP} from "@/utils/httpCommonUtil";
import VueSimpleSpinner from 'vue-simple-spinner'

export interface Owner {
  id: number;
  fullName: string;
}

@Component({
  components: {
    VueSimpleSpinner
  }
})
export default class OwnerSelector extends Vue {
  @Prop({type: String, required: false})
  providerOwner!: string;

  @Prop({type: Boolean, default: true})
  required!: boolean;

  loadingData = false;
  showDropdown = false;
  ownerCandidates = [];

  async toggleDropdown () {
    this.showDropdown = !this.showDropdown;
    if (!this.showDropdown) {
      return;
    }
    this.loadingData = true;
    try {
      const response = await HTTP.get('/api/providers/owner-candidates');
      this.loadingData = false;
      if (!response.data || !response.data.data) {
        throw new Error("Error retrieving provider owner candidates.");
      }
      this.ownerCandidates = response.data.data;
    } catch(err) {
      this.loadingData = false;
      this.$notify({
        group: 'main',
        type: 'error',
        title: 'Error',
        text: 'An error occurred loading provider owner candidates.'
      });
    }
  }

  selectOwner(owner: Owner) {
    this.$emit('owner-selected', owner);
    this.showDropdown = false;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/componentsReusable/OwnerSelector.vue